<script>
import validations from './helpers/validations';
import { useVuelidate } from '@vuelidate/core';

import InputNext from 'next/input/Input.vue';
import TextArea from 'next/textarea/TextArea.vue';
import ButtonNext from 'next/button/Button.vue';
import BotTemplateForm from './BotTemplateForm.vue';

export default {
  components: {
    BotTemplateForm,
    InputNext,
    TextArea,
    ButtonNext,
  },
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
    submitInProgress: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {},
    },
    submitButtonText: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    const formData = this.formData || {};
    const {
      name = '',
      display_name: displayName = '',
      description = '',
      template = null,
    } = formData;

    return {
      name,
      description,
      displayName,
      template,
    };
  },
  validations,
  methods: {
    handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.onSubmit({
        name: this.name,
        display_name: this.displayName,
        description: this.description,
        template: this.template,
      });
    },
  },
};
</script>

<template>
  <div class="mx-0 flex flex-wrap">
    <div class="flex-shrink-0 flex-grow-0 w-[65%]">
      <form
        class="mx-0 flex flex-wrap gap-4 py-4"
        @submit.prevent="handleSubmit"
      >
        <InputNext
          v-model.trim="name"
          :class="{ error: v$.name.$error }"
          class="w-full"
          :label="`${$t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.NAME.LABEL')} *`"
          :placeholder="$t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.NAME.PLACEHOLDER')"
          @input="v$.name.$touch"
        />

        <InputNext
          v-model.trim="displayName"
          :class="{ error: v$.displayName.$error }"
          class="w-full"
          :label="$t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.DISPLAY_NAME.LABEL')"
          :placeholder="
            $t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.DISPLAY_NAME.PLACEHOLDER')
          "
          @input="v$.displayName.$touch"
        />

        <TextArea
          v-model.trim="description"
          custom-text-area-class="!outline !outline-0"
          :class="{ error: v$.description.$error }"
          class="w-full"
          :label="$t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.DESCRIPTION.LABEL')"
          :placeholder="
            $t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.DESCRIPTION.PLACEHOLDER')
          "
          @input="v$.description.$touch"
        />

        <BotTemplateForm v-model="template" class="w-full" />

        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <div class="w-full">
            <ButtonNext
              :disabled="v$.$invalid || submitInProgress"
              :label="submitButtonText"
              :is-loading="submitInProgress"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
